export function createChartData({series,xName=''}) {
    const data = {columns: [xName, ...Object.keys(series[0] ?? {}).filter(item => item !== xName)], rows: series};
    console.log(data);
    return data;
}


export function generateSlideData({data}) {
    const parentArray = data.filter(item => !item.parentId).map(item => ({
            ...item,
            url: item.url ? ('/' + item.url) : ''
        })),
        children = data.filter(item => item.parentId).map(item => ({...item, url: item.url ? ('/' + item.url) : ''}));
    children.forEach(child => {
        const parent = parentArray.find(parent => parent.moduleId === child.parentId);
        if (!parent.children) {
            parent.children = [];
        }
        parent.children.push(child);
    })

    return parentArray;
}

export function generateDepartmentList({data}) {
    const getDepartmentObjFun = (item) => ({value: item.departmentId, label: item.departmentName,});
    const tempArray = [...getRootArray({data}).map(getDepartmentObjFun)];

    function createChildren(parent, data) {
        const childrenArray = getChildrenArray({parentId: parent.value, data}).map(getDepartmentObjFun);
        if (childrenArray.length > 0) {
            parent.children = childrenArray;
            for (let child of parent.children) {
                createChildren(child, data);
            }
        }
    }

    for (let item of tempArray) {
        createChildren(item, data);
    }
    return tempArray;
}

export function generateDepartmentFinalIdArray({departmentId, departmentList}) {
    const queue = [];

    function findTargetId(currentItem, targetId) {
        if (currentItem.value === targetId) {
            return currentItem;
        } else if (currentItem.children && currentItem.children.length > 0) {
            for (let child of currentItem.children) {
                queue.push(child.value);
                const target = findTargetId(child, targetId);
                if (target) {
                    return target;
                } else {
                    queue.pop();
                }
            }
        }
    }

    for (let item of departmentList) {
        queue.push(item.value);
        const target = findTargetId(item, departmentId);
        if (target) {
            return queue;
        } else {
            queue.pop();
        }
    }
    return queue;
}


export function generateDepartmentFinalNameArray({departmentId, departmentList}) {
    const queue = [];

    function findTargetId(currentItem, targetId) {
        if (currentItem.value === targetId) {
            return currentItem;
        } else if (currentItem.children && currentItem.children.length > 0) {
            for (let child of currentItem.children) {
                queue.push(child);
                const target = findTargetId(child, targetId);
                if (target) {
                    return target;
                } else {
                    queue.pop();
                }
            }
        }
    }

    for (let item of departmentList) {
        queue.push(item);
        const target = findTargetId(item, departmentId);
        if (target) {
            return queue;
        } else {
            queue.pop();
        }
    }
    return queue;
}


function findDepartmentObjById({departmentId, departmentList}) {
    function findTargetId(currentItem, targetId) {
        if (currentItem.value === targetId) {
            return currentItem;
        } else if (currentItem.children && currentItem.children.length > 0) {
            for (let child of currentItem.children) {
                const target = findTargetId(child, targetId);
                if (target) {
                    return target;
                }
            }
        }
    }

    for (let item of departmentList) {
        const target = findTargetId(item, departmentId);
        if (target) {
            return target;
        }
    }
}


// const list = generateDepartmentList({data: obj.dt});
//
// console.log(JSON.stringify(generateDepartmentFinalIdArray({departmentId: 6, departmentList: list})));

function getDepartmentObjFun() {
    return (item) => ({value: item.departmentId, label: item.departmentName,});
}

function getChildrenArray({parentId, data}) {
    return data.filter(item => parentId === item.parentId);
}

function getRootArray({data}) {
    return data.filter(item => !item.parentId);
}
